// Shared input/label styling for onboarding forms. Design system: 1px hairline
// border (secondary at 40%), sharp corners, navy border on focus, no shadow.
export const INPUT_CLASS =
  'w-full rounded-none border border-ob-secondary/40 bg-ob-surface-card px-3 py-2.5 ' +
  'font-body text-base text-ob-on-surface placeholder:text-ob-secondary/50 ' +
  'focus:border-ob-ink focus:outline-none focus:ring-0'

export const LABEL_CLASS =
  'mb-1.5 block font-label text-[11px] uppercase tracking-wider text-ob-secondary'

export const HINT_CLASS = 'mt-1 font-body text-xs text-ob-secondary'

export const ERROR_CLASS = 'mt-1 font-body text-xs text-ob-error'
